const event = {
    // current total distance to the top and left
    scrollTop: -1,
    scrollLeft: -1,
    // latest scroll distance on the x-axis and y-axis
    scrollY: -1,
    scrollX: -1,
};
export default function ScrollEvent(scrollTop, scrollLeft, yDistance, xDistance) {
    event.scrollTop = scrollTop;
    event.scrollLeft = scrollLeft;
    event.scrollY = yDistance;
    event.scrollX = xDistance;
    return event;
}
;
//# sourceMappingURL=ScrollEvent.js.map